import { render, staticRenderFns } from "./projectData.vue?vue&type=template&id=336a99ff&"
import script from "./projectData.vue?vue&type=script&lang=js&"
export * from "./projectData.vue?vue&type=script&lang=js&"
import style0 from "./projectData.vue?vue&type=style&index=0&id=336a99ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports